import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Card } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';
import getPhoneNumberValue from 'components/user/phoneNumber.js';
import messages from './messages.js';

const ContactList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const ContactItem = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid ${(p) => p.theme.grayLighter || '#dee2e6'};

  &:last-child {
    border-bottom: 0;
    padding-bottom: 0;
  }

  &:first-child {
    padding-top: 0;
  }
`;

const LabelCell = styled.span`
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;
`;

const NumberCell = styled.span`
  flex-shrink: 0;
  text-align: right;
`;

function EmergencyContactsCard(props) {
  const { emergencyContacts, className } = props;
  const contacts = emergencyContacts
    .map(getPhoneNumberValue)
    .filter((contact) => Boolean(contact.number));

  if (contacts.length === 0) {
    return null;
  }

  return (
    <Card className={className || 'border-0'}>
      <Card.Header>
        <h2 className="card-title"><FormattedMessage {...messages.emergencyContacts} /></h2>
      </Card.Header>
      <Card.Body className="px-0">
        <ContactList>
          {contacts.map((contact) => (
            <ContactItem key={`${contact.label}-${contact.number}`}>
              <LabelCell>{contact.label || '\u00a0'}</LabelCell>
              <NumberCell>{contact.number}</NumberCell>
            </ContactItem>
          ))}
        </ContactList>
      </Card.Body>
    </Card>
  );
}

EmergencyContactsCard.propTypes = {
  emergencyContacts: PropTypes.array,
  className: PropTypes.string,
};

export default EmergencyContactsCard;
